import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-8 md:py-16 px-4 bg-leather bg-blueprint" data-id="element-99">
      <div className="max-w-4xl mx-auto" data-id="element-100">
        <div className="bg-metal border-4 md:border-8 border-[#8B5A2B] p-2 shadow-[0_0_60px_rgba(139,90,43,0.4)]" data-id="element-101">
          <div className="bg-[#111111] p-6 md:p-8 lg:p-12 border-2 md:border-4 border-[#6F6F6F]" data-id="element-102">
            <div className="text-center mb-6 md:mb-8" data-id="element-103">
              <Shield className="w-16 md:w-24 h-16 md:h-24 text-[#8B5A2B] mx-auto mb-4 md:mb-6 drop-shadow-[0_4px_8px_rgba(0,0,0,0.9)]" data-id="element-104" />
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-[#E4D6B5] mb-3 md:mb-4 uppercase tracking-tight" data-id="element-105">
                No Digas "Sí". Solo Di "Quizás"
              </h2>
              <p className="text-lg md:text-2xl text-[#C8B894] mb-4 md:mb-6 font-bold uppercase tracking-wide" data-id="element-106">
                Y Dale Una Prueba LIBRE DE RIESGO Por 7 Días Completos
              </p>
            </div>

            <div className="prose prose-lg max-w-none" data-id="element-107">
              <p className="text-sm md:text-lg text-[#C8B894] leading-relaxed mb-4 md:mb-6 font-semibold" data-id="element-108">
                Odio ver la palabra "garantía" en todos lados. ¿Qué se supone
                que significa? Solo palabras. Promesas vacías para que compres.
              </p>

              <p className="text-sm md:text-lg text-[#C8B894] leading-relaxed mb-6 md:mb-8 font-semibold" data-id="element-109">
                Por eso, te estoy haciendo más que una garantía. Es una promesa
                personal.
              </p>

              <div className="bg-[#8B5A2B] border-2 md:border-4 border-[#6F6F6F] p-6 md:p-8 shadow-[0_4px_0_0_#6F6F6F] md:shadow-[0_8px_0_0_#6F6F6F] mb-6 md:mb-8" data-id="element-110">
                <h3 className="text-xl md:text-3xl font-black text-[#E4D6B5] mb-3 md:mb-4 uppercase tracking-tight" data-id="element-111">
                  Mi Garantía De 7 Días "ÁMALO O DéJALO" — 100% Satisfacción
                </h3>
                <p className="text-base md:text-xl text-[#E4D6B5] leading-relaxed font-semibold" data-id="element-112">
                  Si este no es el recurso de carpintería más completo que hayas
                  visto, simplemente escríbeme y te devuelvo el 100% de tu
                  dinero. Sin preguntas. Sin letra chica.
                </p>
              </div>

              <p className="text-lg md:text-2xl font-bold text-[#E4D6B5] text-center mb-3 md:mb-4 uppercase tracking-wide" data-id="element-113">
                Esta es mi garantía BLINDADA de devolución de dinero.
              </p>

              <p className="text-sm md:text-lg text-[#C8B894] leading-relaxed text-center font-semibold" data-id="element-114">
                Creo con absoluta convicción que este es el paquete de
                carpintería plegable más completo que existe actualmente en
                español… Me tragaría la tierra si pensara que estás
                decepcionado.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="divider-industrial mt-8 md:mt-16" data-id="element-115"></div>
    </section>;
}